
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/teams",
      function () {
        return require("private-next-pages/android/local/teams/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/teams"])
      });
    }
  